<mat-toolbar>
  Servidor Socket
  <span class="spacer"></span>
  <button mat-icon-button matTooltip="Volver a Ajustes" routerLink="/settings"><mat-icon color="primary">arrow_back</mat-icon></button>
  <button mat-icon-button matTooltip="Repetir pruebas" (click)="refreshAll()"><mat-icon color="primary">refresh</mat-icon></button>
</mat-toolbar>

<div class="pageContent">
  <mat-card class="diag-card">
    <mat-card-header>
      <mat-card-title>URL del servidor Socket</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <p class="hint">Se guarda en los ajustes de la aplicación. Todos los usuarios usarán esta URL al conectar.</p>
      <div class="url-row">
        <mat-form-field class="url-field">
          <mat-label>URL Socket.IO</mat-label>
          <input matInput [(ngModel)]="socketUrl" placeholder="https://socket2.retsl.com">
        </mat-form-field>
        <button mat-raised-button color="primary" (click)="saveSocketUrl()">Guardar</button>
        <button mat-stroked-button (click)="resetSocketUrl()">Restaurar</button>
      </div>
      <p class="hint">Por defecto: {{ defaultSocketUrl }}</p>
      @if (urlSavedMessage) {
        <p class="url-saved">{{ urlSavedMessage }}</p>
      }
    </mat-card-content>
  </mat-card>

  <mat-card class="diag-card">
    <mat-card-header>
      <mat-card-title>Socket.IO</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <p class="status-row">
        <mat-icon [class.ok]="socketStatus === 'ok'" [class.err]="socketStatus === 'error'">
          {{ socketStatus === 'ok' ? 'check_circle' : (socketStatus === 'error' ? 'error' : 'hourglass_empty') }}
        </mat-icon>
        {{ socketMessage }}
      </p>
    </mat-card-content>
  </mat-card>

  <mat-card class="diag-card">
    <mat-card-header>
      <mat-card-title>Prueba de comunicación con apps de control</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="hello-row">
        <mat-form-field class="scale-select" appearance="fill">
          <mat-label>Punto de conexión</mat-label>
          <mat-select [(ngModel)]="selectedScaleId" (selectionChange)="onScaleChange()">
            @for (scale of scales; track scale.id) {
              <mat-option [value]="scale.id">{{ scale.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if (scalesLoadError) {
          <p class="hint scales-error">{{ scalesLoadError }}</p>
        }
        <button mat-raised-button color="primary" (click)="testHelloControl()" [disabled]="helloStatus === 'testing'">
          Probar conexión
        </button>
        <button mat-stroked-button (click)="requestPhoto()" [disabled]="!canRequestPhoto()">
          Pedir foto
        </button>
      </div>

      <div class="live-weight-block">
        <p class="live-weight-label">Peso en tiempo real</p>
        <app-lcd-display
          [number]="liveWeight ?? 0"
          [activeColor]="colorBascula"
          [height]="heightBascula"
          [width]="widthBascula"
          [disabledColor]="disabledColorBascula"
          [maxNumberLength]="maxNumberLengthBascula">
        </app-lcd-display>
        @if (liveWeight === null) {
          <p class="hint live-weight-hint">Esperando peso de la app de control para este punto de conexión…</p>
        }
      </div>

      @if (helloStatus !== 'idle') {
        <p class="status-row">
          <mat-icon [class.ok]="helloStatus === 'ok'" [class.err]="helloStatus === 'error'">
            {{ helloStatus === 'ok' ? 'check_circle' : (helloStatus === 'error' ? 'error' : 'hourglass_empty') }}
          </mat-icon>
          {{ helloMessage }}
        </p>
      }

      @if (captureStatus !== 'idle') {
        <p class="status-row">
          <mat-icon [class.ok]="captureStatus === 'ok'" [class.err]="captureStatus === 'error'">
            {{ captureStatus === 'ok' ? 'check_circle' : (captureStatus === 'error' ? 'error' : 'hourglass_empty') }}
          </mat-icon>
          {{ captureMessage }}
        </p>
      }

      @if (previewImageUrl) {
        <div class="preview-image-block">
          <p class="live-weight-label">Última foto recibida</p>
          <img [src]="previewImageUrl" alt="Vista previa de la captura" class="preview-image">
        </div>
      }
    </mat-card-content>
  </mat-card>

  <mat-card class="diag-card conversation-card">
    <mat-card-header>
      <mat-card-title>Comunicación en tiempo real</mat-card-title>
      <span class="spacer"></span>
      <button mat-button (click)="clearConversation()">Limpiar</button>
    </mat-card-header>
    <mat-card-content>
      <p class="hint">Chat de mensajes en tiempo real.</p>
      <div class="conversation-box" #conversationBox>
        @if (conversation.length === 0) {
          <p class="empty-log">Sin mensajes todavía. Conecta una app de control o usa Pesaje para ver la conversación.</p>
        }
        @for (line of conversation; track $index) {
          <div class="conversation-row" [class.row-system]="line.kind === 'system'">
            @if (line.kind !== 'system') {
              <div class="bubble" [class.bubble-angular]="line.kind === 'angular'" [class.bubble-scale]="line.kind === 'scale'" [class.bubble-user]="line.kind === 'user'">
                <span class="bubble-author">{{ line.author }}</span>
                <span class="bubble-text">{{ line.text }}</span>
                <span class="bubble-time">{{ formatTs(line.ts) }}</span>
              </div>
            } @else {
              <div class="system-line">
                <span class="bubble-time">{{ formatTs(line.ts) }}</span>
                {{ line.text }}
              </div>
            }
          </div>
        }
      </div>
      <div class="chat-input-row">
        <mat-form-field class="nick-field">
          <mat-label>Emisor</mat-label>
          <input matInput [(ngModel)]="chatNick" maxlength="32">
        </mat-form-field>
        <mat-form-field class="message-field">
          <mat-label>Mensaje de prueba</mat-label>
          <input matInput [(ngModel)]="chatMessage" (keyup.enter)="sendChat()" maxlength="512">
        </mat-form-field>
        <button mat-raised-button color="primary" (click)="sendChat()" [disabled]="!canSendChat()">Enviar</button>
      </div>
    </mat-card-content>
  </mat-card>
</div>
